/** @format */

import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
	FulfillmentButtonInterface,
	selectShipMode,
	selectShipToMeButtonText,
	setFulfillmentButtonsShipMode
} from '@pdp/add-to-cart/data-access';
import { Observable, Subject, combineLatest, takeUntil } from 'rxjs';
import {
	selectBundleShipToMeButtonText,
	selectEDDDisplayText,
	selectEDDDisplayVerbiage,
	selectResolvedSku
} from '@pdp/data-access/state';

import { ProductAnalyticsService } from '@shared/data-access/services';
import { Store } from '@ngrx/store';
import { Chain, Environment } from '@shared/data-access/interfaces';
import { UtilityService } from '@shared/utils/services';

@Component({
    selector: 'pdp-feature-ship-to-me-button',
    templateUrl: './ship-to-me-button.component.html',
    styleUrls: ['./ship-to-me-button.component.scss'],
    standalone: false
})
export class ShipToMeButtonComponent implements OnInit, OnDestroy {
	@Input() skuEDDEnabled: boolean;
	@Input() isBundle = false;

	shipToMeButtonText$: Observable<FulfillmentButtonInterface>;
	shipMode$ = this.store.select(selectShipMode);
	EDDDisplayText$ = this.store.select(selectEDDDisplayText);
	EDDDisplayVerbiage$ = this.store.select(selectEDDDisplayVerbiage);
	resolvedSku$ = this.store.select(selectResolvedSku);

	private UNSUBSCRIBE$: Subject<void> = new Subject();
	fulfillmentIconName = 'fulfillment-shipping-outlined';

	pdpSkuEDDEventEnabled: boolean;

	constructor(
		private cdr: ChangeDetectorRef,
		private chain: Chain,
		private environment: Environment,
		private productAnalyticsService: ProductAnalyticsService,
		private utilityService: UtilityService,
		private store: Store
	) {}

	ngOnInit(): void {
		this.pdpSkuEDDEventEnabled = this.utilityService.checkKillSwitch(
			'pdpSkuEDDEventEnabled',
			this.environment.killSwitch,
			this.chain.chainIdentifierAbbr
		);

		if (this.isBundle) {
			this.shipToMeButtonText$ = this.store.select(selectBundleShipToMeButtonText);
		} else {
			this.shipToMeButtonText$ = this.store.select(selectShipToMeButtonText);
		}

		combineLatest([this.EDDDisplayText$, this.resolvedSku$]).subscribe((data) => {
			if (this.pdpSkuEDDEventEnabled && data[0]) {
				this.productAnalyticsService.triggerAnalyticsEvent('skuEDD', {
					skuEDD: data[0],
					id: data[1]?.partNumber
				});
			}
		});

		combineLatest([this.shipToMeButtonText$, this.shipMode$])
			.pipe(takeUntil(this.UNSUBSCRIBE$))
			.subscribe(([shipToMeButtonText, shipMode]) => {
				const buttonEnabled = !shipToMeButtonText.fulfillmentButtonDisabledClass;
				this.getFulfillmentIconName(shipMode, buttonEnabled);
				this.cdr.detectChanges();
			});
	}

	ngOnDestroy(): void {
		this.UNSUBSCRIBE$.next();
		this.UNSUBSCRIBE$.complete();
	}

	setShipMode() {
		this.store.dispatch(setFulfillmentButtonsShipMode({ shipMode: 'shipToMe' }));
	}

	getFulfillmentIconName(shipMode: string, buttonEnabled: boolean): void {
		if (shipMode === 'shipToMe' && buttonEnabled) {
			this.fulfillmentIconName = 'fulfillment-shipping-filled';
		} else {
			this.fulfillmentIconName = 'fulfillment-shipping-outlined';
		}
	}
}
